import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class CheckboxComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentCheckbox | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.autofocus = settings?.autofocus ?? false;
		this.conditional = {
			eq:   settings?.conditional?.eq ?? '',
			show: settings?.conditional?.show,
			when: settings?.conditional?.when,
		};
		this.dataGridLabel = settings?.dataGridLabel ?? false;
		this.defaultValue = settings?.defaultValue ?? 'K_NODE;FALSE';
		this.event = {
			onChange: undefined,
			...settings?.event,
		};
		this.falseValue = settings?.falseValue ?? 'K_NODE;FALSE';
		this.input = true;
		this.inputType = settings?.inputType ?? 'checkbox';
		this.kdata = {
			submit: true,
			...settings?.kdata,
		};
		this.labelPosition = settings?.labelPosition ?? 'right';
		this.name = settings?.name ?? '';
		this.persistent = settings?.persistent ?? true;
		this.protected = settings?.protected ?? false;
		this.trueValue = settings?.trueValue ?? 'K_NODE;TRUE';
		this.validate = {
			card: new Card(settings?.validate?.card ?? '0-1'),
			custom: settings?.validate?.custom,
			customMessage: settings?.validate?.customMessage,
		};
		// this.value = settings?.value ?? '';
	}
}
